const MAX_UINT32_VALUE = 4294967295; // 2 ** 32 - 1

export const getRandomValue = (max: number) =>
  Math.ceil(
    (crypto.getRandomValues(new Uint32Array(1))[0] / MAX_UINT32_VALUE) * max,
  );

export const getRandomArray = (length: number) => {
  const result = Array.from({ length }, (_, i) => i + 1);

  result.reduce((acc) => {
    const prev = getRandomValue(acc.length) - 1;
    const next = getRandomValue(acc.length) - 1;
    [acc[prev], acc[next]] = [acc[next], acc[prev]];
    return acc;
  }, result);

  return result;
};
